import './App.css';
import { Provider } from 'react-redux';
import { store } from './app/lib/store/store'
import AppRoutes from './router/index'
import AppWalletProvider from './app/providers/AppWalletProvider';
import { Toaster } from 'sonner';
import { Connection } from '@solana/web3.js';



let mainnet = "https://api.mainnet-beta.solana.com	"
const quickNode = "https://proportionate-warmhearted-putty.solana-mainnet.quiknode.pro/90d4729ba1c52e2aa7db328944713bcd4c408e67"
const chainstackNODE = "https://solana-mainnet.core.chainstack.com/d5a9908d05d47de6ed40506b8d796a3c"
const helius = "https://mainnet.helius-rpc.com/?api-key=e7017d59-07ed-4ad7-955a-5b16d052233e"
let alchemy = "https://solana-mainnet.g.alchemy.com/v2/iG6BiNVyf6NpZSpWiWxlig5X4R1PMSpJ"


window.web3Connection = new Connection(alchemy, 'confirmed')

function App() {


  return (
    <div className='bg-black w-full h-full'>
      <Toaster position="bottom-center" toastOptions={{
        style: {
          borderColor: "rgba(255, 104, 0, 0.2)"
        },
        className: 'bg-yellow-500 text-black bg-opacity-50 backdrop-blur shadow-lg',
      }} />
      <AppWalletProvider>
        <div className='bg-gradient-to-tl from-neutral-900 to-orange-900/10 w-full h-full  '>
          <Provider store={store}>
            <AppRoutes />
          </Provider>
        </div>
      </AppWalletProvider>
    </div>
  );
}

export default App;
